export const defaultTranslations = {
  portal: {
    widgets: {
      claims: {
        actions: {
          create: {
            successNotification: "Success",
            successDescription: "Claim has been created",
            error: "Claim has not been created",
            warning: "Warning",
          },
        },
      },
      newCustomer: {
        messages: {
          success: "Customer Details Created",
          failure: "Customer Details are not saved",
          error: "Error",
        },
      },
      editCustomerDetails: {
        messages: {
          success: "Customer Details Updated",
          failure: "Customer Details are not saved",
          missingPartyID: "Something went wrong",
          error: "Error",
        },
      },
      createPaymentDetail: {
        messages: {
          creationEventSuccesful: "Payment Details Created",
          creationEventFailed: "Payment Details are not saved",
          errorNoPartyID: "Something went wrong",
          errorUnspecified: "Error",
        },
      },
    },
    errorHandling: {
      errorCodes: {
        general: {
          message: {
            FALLBACK_ERROR: "Unknown error",
          },
          title: {
            FALLBACK_ERROR: "Unknown error",
            MERGE_DOCUMENTS: "Document warning",
          },
        },
      },
    },
  },
};
